import React from "react";
import Typed from "react-typed";
import { Link } from "react-scroll";

const Header = () => {
  return (
    <div className="home header-wrapper">
      <div className="main-info">
        <h1 className="header-text">
          Hello! <br /> I'm Jennifer Kramer. <br /> This is what I love to do:
        </h1>
        <Typed
          id="home"
          className="typed-text"
          strings={[
            "Web Design | Development",
            "UX / UI Design",
            "Graphic Design",
            "Illustration",
            "Traditional Painting",
            "Forever Learning",
          ]}
          typeSpeed={80}
          backSpeed={40}
          loop
        />
        <div className="main-header-buttons">
          <Link
            smooth={true}
            to="portfolio"
            offset={-100}
            href="#"
            className="btn-main-offer"
          >
            Portfolio
          </Link>
          <Link
            smooth={true}
            to="contact"
            offset={-100}
            href="#"
            className="btn-main-offer"
          >
            Contact Me
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Header;
